import { IUser } from 'src/interfaces/user';
import { TColumn } from '../components/types';
import { isPermissionGranted } from 'src/utils/permissions/isPermissionGranted';
import {
    TICKETS_RATING_AUTH,
    READ_PERMISSION,
} from 'src/constants/permissions';

type TShouldRenderCell = {
    column: TColumn;
    user: IUser;
};

/**
 * Determines whether to render a cell based on column authorization and user access level.
 * @param {TColumn} column - The column configuration object.
 * @param {IUser} user - The user object.
 * @returns {boolean} Returns true if the cell should be rendered, false otherwise.
 */

export const shouldRenderCell = ({ column, user }: TShouldRenderCell) => {
    if (column?.authorized) {
        return isPermissionGranted({
            permissions: user?.permissions || {},
            permission: TICKETS_RATING_AUTH,
            crud: READ_PERMISSION,
        });
    } else {
        return true;
    }
};
